/* eslint-disable max-len */
const vxCore = require('./vx-core');
const accounting = require('./accounting');
const client = require('./client');
const collateral = require('./collateral');
const vx = require('./vx');
/**
 * Sale related validation schemas
 * @module schemas/sales
 * @property {module:schemas/sales/vxcore} vx-core - schema compliant file for sales vx-core
 * @property {module:schemas/sales/accounting} accounting - schema compliant file for sales accounting
 * @property {module:schemas/sales/client} client - schema compliant file for sales client
 * @property {module:schemas/sales/collateral} collateral - schema compliant file for sales collateral
 * @property {module:schemas/sales/vx} vx - schema compliant file for sales vx
 */
module.exports = {
  vxCore,
  accounting,
  client,
  collateral,
  vx,
};
